import moment from 'moment'

export const timeUntilExpiry = membership => moment(membership.expires_at).fromNow()
